module.exports = __webpack_public_path__ + "img/12 Aniamtion 3-squashed.eeb2c7f4.jpg";